import axios from 'axios';

const API_BASE_URL = 'https://book-lovers-4592.onrender.com/auth';

export const register = async (userData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/register`, userData);
    return response.data;
  } catch (error) {
    console.error("Registration Error:", error.response);
    throw error;
  }
};

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, { username, password });
    if (response.data) {
      sessionStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  } catch (error) {
    console.error("Login Error:", error.response);
    throw error;
  }
};

export const logout = () => {
  sessionStorage.removeItem('user');
  localStorage.removeItem('user');
};

export const getCurrentUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  return null;
};

export const forgotPassword = (email) => {
  return axios.post(`${API_BASE_URL}/forgot-password`, { email });
};

export const resetPassword = (token, password) => {
  return axios.post(`${API_BASE_URL}/reset-password/${token}`, { password });
};

const authService = { forgotPassword, resetPassword, register, login, logout, getCurrentUser };
export default authService;
